import Printd from 'printd';
export default {
  name: 'add-extra-charges-pdf',
  components: {  Printd  },
  props: ['payload'],
  data() {
    return {
      awbChargesData: JSON.parse(JSON.stringify(this.payload)),
    }
  },
  mounted() {
  },
  methods: {
  }
}



// WEBPACK FOOTER //
// ./src/modules/firstAndLastmilemanagement/views/TripManagement/AddExtraCharges/AddExtraChargesPDF/AddExtraChargesPDF.js